<template>
	<transition name="new_channel">
		<div class="new_channel">
			<button @click="backPage">back</button>
			<!--<button @click="yetChannel"-->
			<!--v-if="getUserRights"-->
			<!--&gt;more channels-->
			<!--</button>-->
			<div class="wrap">
				<p>добавление нового канала
				</p>
				<p>имя канала: {{playlist.name}}</p>
			</div>
			<div class="container">
				<!--<div class="wrap_options">-->
				<!--<label for="number">Номер кнопки</label>-->
				<!--<input type="text"-->
				<!--id="number"-->
				<!--:value="playlist.button"-->
				<!--@blur="edit"-->
				<!--onkeyup="this.value = this.value.replace(/[^0-9]+$/, '')"-->
				<!--@focus="error = false"-->
				<!--/>-->
				<!--</div>-->
				<div class="wrap_options">
					<label for="disp_name">Отображаемое название</label>
					<input type="text"
					       id="disp_name"
					       :value="playlist.display_name"
					       @blur="edit"
					       @focus="error = false; no_correct = false"/>
				</div>
				<div class="wrap_options">
					<label for="name">Название канала на стримере</label>
					<input type="text" id="name"
					       :value="playlist.name"
					       @blur="edit"
					       @focus="error = false; no_correct = false"
					       onkeyup="this.value = this.value.replace(/[^-0-9a-zA-Z]+$/, '')"/>
				</div>
				<div class="wrap_options">
					<label for="genreList">
						<span>Жанр канала</span>
						<input type="button"
						       title="добавить еще жанр"
						       @click="newGanre">
					</label>
					<div id="genreList">
						<transition-group name="list-complete" tag="div">
							<div v-for="(group, i) in playlist.genreList"
							     :key="i"
							     class="list-complete-item">
								<select title="genreList"
								        name="display_name"
								        @blur="edit"
								        @focus="error = false; no_correct = false"
								        :id="i">
									<option :value="item.name"
									        v-for="(item, i) in genreList"
									        :key="i">{{item.display_name}}
									</option>
								</select>
								<input type="button" title="удалить жанр" @click="deleteGenre">
							</div>
						</transition-group>
					</div>
				</div>
				<div class="wrap_options">
					<label for="censore">Возрастное ограничение</label>
					<select title="censore"
					        name="censore"
					        id="censore"
					        @blur="edit"
					        @focus="error = false; no_correct = false">
						<option value="0">
							Без ограничений
						</option>
						<option value="1">
							Для взрослых
						</option>
					</select>
				</div>
				<div class="wrap_options">
					<label for="federal">Федеральный</label>
					<select title="federal"
					        name="federal"
					        id="federal"
					        @blur="edit"
					        @focus="error = false; no_correct = false">
						<option value="0">
							Нет
						</option>
						<option value="1">
							Да
						</option>
					</select>
				</div>
				<div class="wrap_options">
					<label for="free">free</label>
					<select title="free"
					        name="free"
					        id="free"
					        @blur="edit"
					        @focus="error = false; no_correct = false">
						<option value="0">
							Нет
						</option>
						<option value="1">
							Да
						</option>
					</select>
				</div>
				<div class="wrap_options"
				     v-show="getReqUserRole === 'Администратор уровня Бог'">
					<label for="ott_free">OTT free</label>
					<select title="ott_free"
					        name="ott_free"
					        id="ott_free"
					        @blur="edit"
					        @focus="error = false; no_correct = false">
						<option value="0">
							Нет
						</option>
						<option value="1">
							Да
						</option>
					</select>
				</div>
				<!--<div class="wrap_options"-->
				<!--v-show="false">-->
				<!--<label for="url">URL</label>-->
				<!--<input type="text"-->
				<!--id="url"-->
				<!--:value="playlist.url"-->
				<!--disabled-->
				<!--@blur="edit"-->
				<!--@focus="error = false; no_correct = false"-->
				<!--onkeyup="this.value = this.value.replace(/[^-.\/0-9_a-zA-Z]+$/, '')"/>-->
				<!--</div>-->
				<div class="wrap_options">
					<label for="archive">Архив (часы)</label>
					<input type="text"
					       id="archive"
					       :value="playlist.archive_limit"
					       @blur="edit"
					       @focus="error = false; no_correct = false"
					       onkeyup="this.value = this.value.replace(/[^0-9]+$/, '')"/>
				</div>
				<div class="wrap_options">
					<label for="poster">Постер</label>
					<input type="text"
					       id="poster"
					       :value="playlist.poster_url"
					       @blur="edit"
					       @focus="error = false; no_correct = false"
					       onkeyup="this.value = this.value.replace(/[^-.:\/0-9_a-zA-Z]+$/, '')"/>
				</div>
				<div class="wrap_options">
					<label for="epg_api">Epg API</label>
					<input type="text"
					       id="epg_api"
					       :value="playlist.epg_api_id"
					       @blur="edit"
					       @focus="error = false; no_correct = false"
					       onkeyup="this.value = this.value.replace(/[^0-9]+$/, '')"/>
				</div>
				<div class="wrap_options">
					<label for="epg_jtv">Epg JTV</label>
					<input type="text"
					       id="epg_jtv"
					       :value="playlist.epg_jtv"
					       @blur="edit"
					       @focus="error = false; no_correct = false"
					       onkeyup="this.value = this.value.replace(/[^-\/0-9_a-zA-Z]+$/, '')"/>
				</div>
				<div class="wrap_options"
				     v-if="getReqUserRole === 'Администратор уровня Бог' && getViewUser === 'root'">
					<label for="operator">Оператор</label>
					<select name="operator"
					        id="operator"
					        v-model="getChannelList[getCountChannel].operator">
						<option :value="operator.name"
						        :key="operator.name"
						        v-for="operator in operatorList">{{operator.display_name}}
						</option>
					</select>
				</div>
			</div>
			<button @click="save">save
			</button>
			<transition name="error">
				<p id="error"
				   v-if="error">все поля должны быть заполнены!!!</p>
				<p id="no_correct"
				   v-if="no_correct">не корректно введены данные!!!</p>
			</transition>
		</div>
	</transition>
</template>
<script>
	import { mapGetters, mapActions } from "vuex";
	import { performRequest }         from "../script/ws/wsclient";

	export default {
		name:     "NewChannel",
		data() {
			return {
				genreList:    "",
				playlist:     {
					archive_limit: 48,
					display_name:  "",
					name:          "",
					poster_url:    "http://portal.tv.kvant-telecom.ru/image/",
					is_censored:   "",
					is_federal:    "",
					genreList:     [
						{
							name:         "",
							display_name: ""
						}
					],
					epg_api_id:    "",
					epg_jtv:       ""
				},
				error:        false,
				no_correct:   false,
				operatorList: null
			};
		},
		beforeMount() {
			this.genreList = this.getGenre;
			if (this.getReqUserRole === "Администратор уровня Бог") {
				performRequest(
					{
						section: "tvcontent.operator",
						name:    "getOperatorList"
					},
					{
						operator: this.getViewUser
					},
					a => {
						if (a.code === 200) {
							this.operatorList = a.data;
							console.log(a);
						} else {
							console.log("ошибка загрузки списка операторов");
						}
					});
			}
			// performRequest(
			// 	{
			// 		section: "tvcontent.genre",
			// 		name:    "getGenreList"
			// 	},
			// 	null,
			// 	a => {
			// 		if (a.code === 200) {
			// 			this.playlist.genreList.display_name = a.data[0].display_name;
			// 			this.playlist.genreList.name = a.data[0].name
			// 		} else {
			// 			console.log("ошибка при получении жанров");
			// 		}
			//
			// 	}
			// );
		},
		updated() {
			try {
				let options = Array.from(
					document.querySelectorAll("#genreList div div select")
				);
				for (let item in options) {
					let optionItem = options[item].children;
					for (let elem in optionItem) {
						if (
							optionItem.hasOwnProperty(elem) &&
							this.playlist.genreList[item] &&
							this.playlist.genreList[item].name ===
							optionItem[elem].getAttribute("value")
						) {
							options[item].options.selectedIndex = elem;
						}
					}
				}
				document.querySelector(
					"select#censore"
				).selectedIndex = this.playlist.is_censored;
				document.querySelector(
					"select#federal"
				).selectedIndex = this.playlist.is_federal;
			} catch (e) {
				console.log("error", e);
			}
		},
		methods:  {
			...mapActions(["setChannelist"]),
			backPage() {
				this.$router.go(-1);
			},
			save() {
				if (
					document.querySelector("#archive").value.trim() !== "" &&
					document.querySelector("#disp_name").value.trim() !== "" &&
					document.querySelector("#name").value.trim() !== "" &&
					document.querySelector("#poster").value.trim() !== "" &&
					document.querySelector("#epg_api").value.trim() !== "" &&
					document.querySelector("#epg_jtv").value.trim() !== ""
				) {

					// for (let elem in this.playlist.genreList) {
					// 	if (this.playlist.genreList.hasOwnProperty(elem)) {
					// 		let value = this.playlist.genreList[elem].name;
					// 		for (let elem2 in this.playlist.genreList) {
					// 			if (this.playlist.genreList.hasOwnProperty(elem2)) {
					// 				if (this.playlist.genreList[elem] !== this.playlist.genreList[elem2]) {
					// 					if (value === this.playlist.genreList[elem2].name) {
					// 						this.playlist.genreList.splice(elem2, 1);
					// 					}
					// 				}
					// 			}
					// 		}
					// 	}
					// }


					this.playlist.genreList.splice(0, this.playlist.genreList.length);
					let genreList = Array.from(
						document.querySelectorAll("#genreList div div select")
					);
					for (let i in genreList) {
						let obj = {
							name:         genreList[i].children[genreList[i].selectedIndex].value,
							display_name: genreList[i].children[
								              genreList[i].selectedIndex
								              ].innerText
								              .replace(/\r|\n/g, "")
								              .trim()
						};
						this.playlist.genreList.push(obj);
					}


					this.getPlaylist.push(this.playlist);

					this.playlist.operator = this.getViewUser;

					performRequest(
						{
							section: "tvcontent.channel",
							name:    "createChannel"
						},
						this.playlist
						,
						a => {
							if (a.code === 200) {
								this.playlist.old_name = this.playlist.name;
								this.$router.go(-1);
							} else if (a.code === 500) {
								this.no_correct = true;
							} else {
								console.log("ошибка при отправке");
							}
						}
					);
				} else {
					this.error = true;
				}
			},
			newGanre() {
				performRequest(
					{
						section: "tvcontent.genre",
						name:    "getGenreList"
					},
					{
						operator: this.getViewUser
					},
					a => {
						if (a.code === 200) {
							this.playlist.genreList.push({
								name:         this.playlist.genreList.name = a.data[0].name,
								display_name: this.playlist.genreList.display_name = a.data[0].display_name
							});
						} else {
							console.log("ошибка при получении жанров");
						}

					}
				);

			},
			deleteGenre(e) {
				this.playlist.genreList.splice(e.target.previousElementSibling.id, 1);
			},
			edit() {
				this.playlist.genreList.splice(0, this.playlist.genreList.length);
				let genreList = Array.from(
					document.querySelectorAll("#genreList div div select")
				);
				for (let i in genreList) {
					let obj = {
						name:         genreList[i].children[genreList[i].selectedIndex].value,
						display_name: genreList[i].children[
							              genreList[i].selectedIndex
							              ].innerText
							              .replace(/\r|\n/g, "")
							              .trim()
					};
					this.playlist.genreList.push(obj);
				}

				this.playlist.archive_limit = +document.querySelector("#archive")
					.value;
				this.playlist.display_name  = document.querySelector(
					"#disp_name"
				).value;
				this.playlist.name          = document.querySelector("#name").value;
				this.playlist.poster_url    = document.querySelector("#poster").value;
				this.playlist.is_censored   = document.querySelector(
					"#censore"
				).selectedIndex;
				this.playlist.is_federal    = document.querySelector(
					"#federal"
				).selectedIndex;
				this.playlist.is_free       = document.querySelector(
					"#free"
				).selectedIndex;
				this.playlist.is_ottfree    = document.querySelector(
					"#ott_free"
				).selectedIndex;

				this.playlist.epg_api_id = +document.querySelector("#epg_api").value;
				this.playlist.epg_jtv    = document.querySelector("#epg_jtv").value;
				if (this.getReqUserRole === "Администратор уровня Бог" && this.getViewUser === "root") {
					this.playlist.operator = this.operatorList[document.querySelector(
						"#operator"
					).selectedIndex].name;
				}
			}
		},
		computed: {
			...mapGetters([
				"getCountPlaylists",
				"getGenre",
				"getGenreList",
				"getPlaylists",
				"getPlaylist",
				"getCountChannel",
				"getUserRights",
				"getReqUserRole",
				"getChannelList",
				"getCurrentOperator",
				"getViewUser"
			])
		}
	};
</script>
<style scoped lang="scss">
	.new_channel {
		background-color: rgba(238, 238, 200, 0.8);
		box-shadow: inset 0 0 5px rgba(#333, 0.4), 1px 1px 5px #333;
		padding: 0.5rem 0.5rem 1rem 0.5rem;
		height: calc(100vh - 5rem);
		overflow: auto;
		min-width: 420px;
		width: 90%;
		margin-left: 50%;
		transform: translateX(-50%);
		margin-top: 4rem;
		position: absolute;
		button {
			background: #bbf291;
			border-radius: 0.2rem;
			line-height: 1.8rem;
			border: none;
			outline: none;
			height: 2.5rem;
			padding: 0.2rem 1rem;
			transition: all 0.2s;
			cursor: pointer;
			margin: 0.5rem;
			
			&:hover {
				background: #78956b;
				color: white;
				
				&:active {
					box-shadow: 0 0 1rem #967068;
				}
			}
		}
		button[title='newChannel'], select[title='select'] {
			display: none;
			
			option {
				background-color: #fff;
				color: #000;
			}
		}
		
		.container {
			clear: both;
			margin: 0.5rem 0.5rem 0.5rem 50%;
			width: 90%;
			transform: translateX(-50%);
			.wrap_options {
				width: 100%;
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				margin: 0.5rem;
				input[type="button"] {
					outline: none;
					border: none;
					background: url("../../static/plus.png") no-repeat center;
					background-size: 75%;
					width: 2rem;
					height: 2rem;
					position: absolute;
					top: -3px;
					left: 6.5rem;
					cursor: pointer;
				}
				input[type='text'], select#censore, select#federal, select#ott_free, select#operator, select#free {
					min-width: 20rem;
					max-width: 50rem;
					border-radius: 3px;
					outline: none;
					border: 1px solid #c9c9c9;
					padding-left: 5px;
					flex-grow: 1;
					margin-bottom: 5px;
					&:focus {
						box-shadow: 0 0 5px #69bf8f;
					}
				}
				#genreList {
					min-width: 20rem;
					max-width: 50rem;
					flex-grow: 1;
					div {
						div {
							display: flex;
							flex-direction: row;
							justify-content: space-between;
							flex-grow: 1;
							select {
								flex-grow: 1;
								border-radius: 3px;
								outline: none;
								border: 1px solid #c9c9c9;
								padding-left: 2px;
								margin-bottom: 5px;
								&:focus {
									box-shadow: 0 0 5px #69bf8f;
								}
							}
							input[type="button"] {
								outline: none;
								border: none;
								background: url("../../static/minus.png") no-repeat center;
								background-size: 75%;
								width: 2rem;
								height: 2rem;
								top: -3px;
								left: 6.5rem;
								cursor: pointer;
								position: static;
								margin-top: -3px;
							}
						}
					}
				}
				select#censore, select#federal, select#ott_free, select#free {
					padding-left: 2px;
				}
				
				label {
					width: 18rem;
					position: relative;
				}
			}
		}
		p#error, p#no_correct {
			display: inline-block;
			font-size: 1.1rem;
			color: red;
		}
		.wrap {
			margin: 0.1rem 0.5rem;
			float: right;
			
			p {
				margin: 0;
			}
			
			.bold {
				font-weight: bold;
			}
		}
	}
	@media (max-width: 750px) {
		.new_channel {
			height: calc(100vh - 5rem);
			width: 90%;
			min-width: 380px;
			overflow: auto;
			
			button[title='newChannel'], select[title='select'] {
				display: inline-block;
			}
		}
	}
	@media (max-width: 620px) {
		.new_channel {
			margin-top: 8rem;
			height: calc(100vh - 9rem);
		}
	}
	.list-complete-item {
		transition: all .5s;
	}
	.list-complete-enter {
		opacity: 0;
		transform: translateX(30px);
	}
	.list-complete-leave-to {
		opacity: 0;
		transform: translateX(-30px);
	}
	.error-enter-active,
	.new_channel-enter-active {
		transition: all 0.5s ease;
	}
	.error-leave-active,
	.new_channel-leave-active {
		transition: all 0.5s ease;
	}
	.error-enter,
	.new_channel-enter,
	.error-leave-to,
	.new_channel-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/NewChannel.vue